import './ticketReport.scss';
import { Dispatch, SetStateAction, useState, useEffect, useRef, useCallback } from 'react';
import moment from 'moment';
import api, { API_URI } from 'api';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

function TicketReport({
    open,
    setOpen
} : {
    open: boolean,
    setOpen: Dispatch<SetStateAction<boolean>>,
    
}) {
    const params: any = useParams();
    const [members, setMembers] = useState<any>([]);
    const dateFromRef = useRef<HTMLInputElement>(null);
    const [report, setReport] = useState<{dateFrom: string, dateTo: string}>({
        dateFrom: '',
        dateTo: ''
    });

    const toggleMember = (index: number, checked: boolean) => {
        const copiedData = [...members];
        copiedData[index] = {
            ...copiedData[index],
            Selected: checked
        }
        setMembers(copiedData);
    }

    const generateReport = () => {
        if (!report.dateFrom) { toast.warning("Please specify a start date"); dateFromRef.current?.focus(); return; }
        api.report.generateBoardReport(params.boardId, new Date(report.dateFrom), new Date(report.dateTo ? new Date(new Date(report.dateTo)).setHours(23, 59) : new Date().setDate(new Date().getDate() + 1)))
        setOpen(false);
        toast.info("The report has requested and will download when done generating");
        setReport({
            dateFrom: '',
            dateTo: ''
        })
    }

    const getMembers = useCallback(() => {
        api.board.member.getAll(params.boardId).then(data => {
            setMembers(data.map((member: any) => {
                return {
                    Id: member.Id,
                    Name: member.Name,
                    Surname: member.Surname,
                    Selected: true
                }
            }));
        });
    }, [params.boardId])

    useEffect(() => {
        getMembers();
    }, [getMembers])

    return (
        <div className={`ticket-report ${open ? 'open' : ''}`} onClick={e => e.stopPropagation()}>
            <div className="input-group">
                <label>Date From:</label>
                <input type="date" ref={dateFromRef} value={moment(report.dateFrom).format("YYYY-MM-DD") || ''} onChange={e => setReport({
                        ...report,
                        dateFrom: e.currentTarget.value
                    })} 
                />
            </div>
            <div className="input-group">
                <label>Date To: <span>(leave empty for current date)</span></label>
                <input type="date" value={moment(report.dateTo).format("YYYY-MM-DD") || ''} onChange={e => setReport({
                    ...report,
                    dateTo: e.currentTarget.value
                })} />
            </div>
            <button onClick={generateReport}>Generate</button>
        </div>
    )
}

export default TicketReport;